export const textToRemove =
	"I am taking (or have recently stopped taking) a medicine (not listed above) that I’d like to discuss with the pharmacist";